export const groupConstants = {
    GETALL_REQUEST: "GROUP_GETALL_REQUEST",
    GETALL_SUCCESS: "GROUP_GETALL_SUCCESS",
    GETALL_FAILURE: "GROUP_GETALL_FAILURE",

    GET_GROUP_ACTION_REQUEST: "GET_GROUP_ACTION_REQUEST",
    GET_GROUP_ACTION_SUCCESS: "GET_GROUP_ACTION_SUCCESS",
    GET_GROUP_ACTION_FAILURE: "GET_GROUP_ACTION_FAILURE"
}